<template>
  <div :style="{'background-color':'#F7F7F7'}">
<!--    <van-nav-bar title="告警中心" id="topbar"/>-->

    <div class="content">

      <div class="monitor-section pending-section">
        <div class="time-range-buttons">
          <van-button @click="showDatePicker('start')" class="time-button">
            {{ startTime || '开始时间' }}
          </van-button>
          <span class="time-separator"> ~ </span>
          <van-button @click="showDatePicker('end')" class="time-button">
            {{ endTime || '结束时间' }}
          </van-button>
          <van-button type="primary" @click="filterAlarms" class="filter-button">
            查询
          </van-button>
        </div>
      </div>

      <!-- 待处理告警 -->
      <div class="monitor-section pending-section">
        <div class="section-title">
          待处理告警
          <span class="alarm-count">({{ pendingAlarms.length }})</span>
        </div>
        <div class="scrollable-list">
          <div v-if="pendingAlarms.length === 0 && pendingFinished" class="empty-alarm">
            <div class="empty-icon">
              <van-icon name="success" size="48" color="#52C41A" />
            </div>
            <div class="empty-text">暂无待处理告警</div>
            <div class="empty-subtext">系统运行正常</div>
          </div>
          <div v-else>
            <van-pull-refresh v-model="pendingRefreshing" @refresh="onPendingRefresh">
              <van-list v-model="pendingLoading" :finished="pendingFinished"
                :finished-text="pendingAlarms.length === 0 ? '' : '没有更多数据了'"
                @load="loadPendingAlarms" :immediate-check="false"
                class="alarm-list" :style="{ height:  dataListHeight + 'px' }">

                <div class="alarm-item pending" v-for="(item, index) in pendingAlarms" :key="index">
                  <div class="alarm-icon">
                    <van-icon name="warning" size="24" color="#FF4D4F" />
                  </div>
                  <div class="alarm-content">
                    <div class="alarm-header">
                      <h4 class="alarm-title">{{ item.alarmName }}</h4>
                      <span class="alarm-time">{{ getTimeRange(item.alarmStartTime,item.alarmEndTime) }}</span>
                    </div>
                    <p class="alarm-desc-no">监测值：{{item.minValue && item.maxValue ? item.minValue + "~" + item.maxValue : " - - " }},阈值区间：{{item.rangeValue}}</p>
                  </div>
                  <div class="alarm-action">
                    <van-button type="primary" size="small" @click="handleAlarm(item)" class="action-button">
                      处理告警
                    </van-button>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </div>

      <!-- 已处理告警 -->
      <div class="monitor-section processed-section">
        <div class="section-title">已处理告警</div>
        <div class="scrollable-list">
          <div v-if="processedAlarms.length === 0 && processedFinished" class="empty-alarm">
            <div class="empty-icon">
              <van-icon name="clock-o" size="48" color="#999" />
            </div>
            <div class="empty-text">暂无已处理告警</div>
            <div class="empty-subtext">暂无历史处理记录</div>
          </div>
          <div v-else>
            <van-pull-refresh v-model="processedRefreshing" @refresh="onProcessedRefresh">
              <van-list v-model="processedLoading" :finished="processedFinished"
                :finished-text="processedAlarms.length === 0 ? '' : '没有更多数据了'"
                @load="loadProcessedAlarms" :immediate-check="false"
                class="alarm-list" :style="{ height:  dataListHeight + 'px' }">

                <div class="alarm-item processed" v-for="(item, index) in processedAlarms" :key="index">
                  <div class="alarm-icon">
                    <van-icon name="success" size="24" color="#52C41A" />
                  </div>
                  <div class="alarm-content">
                    <div class="alarm-header">
                      <h4 class="alarm-title">{{ item.alarmName }}</h4>
                      <span class="alarm-time">{{ getTimeRange(item.alarmStartTime,item.alarmEndTime) }}</span>
                    </div>
                    <p class="alarm-desc">监测值：{{item.minValue && item.maxValue ? item.minValue + "~" + item.maxValue : " - - " }},阈值区间：{{item.rangeValue}}</p>
                    <div class="alarm-handler">
                      <span class="handler-label">已处理</span>
                      <span class="handler-name">{{ item.userName }}</span>
                    </div>
                  </div>
                  <div class="alarm-action">
                    <van-button type="primary" size="small" @click="handleView(item)" class="action-button-2">详情</van-button>
                  </div>
                </div>
              </van-list>
            </van-pull-refresh>
          </div>
        </div>
      </div>
    </div>
    <!-- 处理告警对话框 -->
    <van-dialog v-model="dialogVisible" title="处理告警" width="80%" :show-confirm-button="false">

      <van-form style="padding: 10px 10px 0" label-width="65px">
        <van-field v-model="formData.userName"
                   label="处理人" required colon
                   style="line-height: 2"
                   placeholder="请输入处理人姓名"
                   class="custom-field"/>
        <van-field v-model="formData.measures"
                   label="描述" colon
                   type="textarea"
                   style="line-height: 2"
                   placeholder="请输入处理措施..."
                   rows="2"/>

        <div style="margin: 16px; display: flex; justify-content: center; gap: 10px">
          <van-button class="confirm-btn" @click="submitForm">提交处理</van-button>
          <van-button class="cancel-btn" @click="dialogVisible = false">取消</van-button>
        </div>
      </van-form>
    </van-dialog>
    <!-- 查看详情对话框 -->
    <van-dialog v-model="viewDialog" title="描述" width="80%" :show-confirm-button="false">

      <van-form style="padding: 10px 10px 0" label-width="65px">
       <van-field v-model="formView.measures" type="textarea" disabled readonly
                  :autosize="true" rows="2" style="line-height: 2" placeholder="暂无描述内容..."/>
        <div style="margin: 16px; display: flex; justify-content: center; gap: 10px">
          <van-button class="cancel-btn" @click="viewDialog = false">关闭</van-button>
        </div>
      </van-form>
    </van-dialog>
    <!-- 时间选择器弹窗 -->
    <van-popup v-model="showDatePickerFlag" position="bottom"  :style="{height: '40%'}">
      <van-datetime-picker type="date" v-model="currentDate" @confirm="confirmDate" @cancel="showDatePickerFlag = false" title="选择时间"/>
    </van-popup>
    <!--   底部定义组件   -->
    <tabular :active="1"/>
  </div>
</template>
<script>
import $ from '@/fly'
import Tabular from '@/components/tabbar.vue';
import { Dialog, Toast } from 'vant';
import _ from 'lodash';

export default {
  name: 'alarm-alarmInfo',
  components: { Tabular },
  data () {
    return {
      clientHeight: window.screen.height,
      // 对话框相关
      dialogVisible: false,
      viewDialog: false,
      formData: {
        userName: '',
        measures: ''
      },
      formView: {
        measures: ''
      },
      showDatePickerFlag: false,
      currentDatePicker: '',
      currentDate: new Date(),
      // 分页相关变量
      pendingLoading: false,
      pendingFinished: false,
      processedLoading: false,
      processedFinished: false,
      // 下拉刷新相关变量
      pendingRefreshing: false,
      processedRefreshing: false,
      pendingPage: 1,
      processedPage: 1,
      pageSize: 10,
      // 时间范围查询相关变量
      startTime: '',
      endTime: '',
      // 展示的告警数据
      pendingAlarms: [],
      processedAlarms: [],
      dataListHeight: 0,
    }
  },
  methods: {
    // 初始化数据
    initData () {
      this.setDateRange()
      this.getUntreatedAlarmData()
      this.getProcessedAlarmData()
    },
    // 获取未处理数据列表
    getUntreatedAlarmData() {
      this.pendingLoading = true;
      $.get('mobile/alarm/alarmData', {
        pageNum: this.pendingPage,
        pageSize: this.pageSize,
        status: '0',
        startTime: this.startTime,
        endTime: this.endTime
      }).then(res => {
        const data = res.data || [];
        if (data.length === 0) {
          this.pendingFinished = true;
        } else {
          if (this.pendingPage === 1) {
            this.pendingAlarms = [...data];
          } else {
            this.pendingAlarms = [...this.pendingAlarms, ...data];
          }
          this.pendingFinished = data.length < this.pageSize;
        }
      }).catch(() => {
        this.pendingFinished = true;
      }).finally(() => {
        this.pendingLoading = false;
        this.pendingRefreshing = false;
        if (!this.pendingFinished) {
          this.pendingPage++;
        }
      })
    },
    // 获取已处理数据列表
    getProcessedAlarmData() {
      this.processedLoading = true;
      $.get('mobile/alarm/alarmData', {
        pageNum: this.processedPage,
        pageSize: this.pageSize,
        status: '1',
        startTime: this.startTime,
        endTime: this.endTime
      }).then(res => {
        const data = res.data || [];
        if (data.length === 0) {
          this.processedFinished = true;
        } else {
          if (this.processedPage === 1) {
            this.processedAlarms = [...data];
          } else {
            this.processedAlarms = [...this.processedAlarms, ...data];
          }
          this.processedFinished = data.length < this.pageSize;
        }
      }).catch(() => {
        this.processedFinished = true;
      }).finally(() => {
        this.processedLoading = false;
        this.processedRefreshing = false;
        if (!this.processedFinished) {
          this.processedPage++;
        }
      })
    },
    // 设置默认时间
    setDateRange() {
      // 默认近7天数据，格式为yyyy-mm-dd
      const endDate = new Date();
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);

      // 格式化日期为yyyy-mm-dd格式
      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      };

      this.startTime = formatDate(startDate);
      this.endTime = formatDate(endDate);
    },
    // 显示日期选择器
    showDatePicker(type) {
      this.currentDatePicker = type;
      this.showDatePickerFlag = true;
    },
    // 确认日期选择
    confirmDate(value) {
      // 格式化日期为yyyy-mm-dd格式
      const year = value.getFullYear();
      const month = String(value.getMonth() + 1).padStart(2, '0');
      const day = String(value.getDate()).padStart(2, '0');
      const formattedDate = `${year}-${month}-${day}`;

      if (this.currentDatePicker === 'start') {
        this.startTime = formattedDate;
      } else {
        // 检查结束时间是否大于开始时间
        if (this.startTime && new Date(formattedDate) < new Date(this.startTime)) {
          Dialog.alert({
            title: '提示',
            message: '结束时间不能小于开始时间'
          });
          return;
        }
        this.endTime = formattedDate;
      }
      this.showDatePickerFlag = false;
    },
    // 过滤告警数据
    filterAlarms() {
      this.pendingPage = 1;
      this.processedPage = 1;
      this.pendingFinished = false;
      this.processedFinished = false;
      this.pendingAlarms = [];
      this.processedAlarms = [];

      // 重新获取数据
      this.getUntreatedAlarmData();
      this.getProcessedAlarmData();
    },
    // 获取告警时间范围
    getTimeRange (startTime,endTime) {
      if (startTime !== null && startTime !== undefined && endTime !== null && endTime !== undefined) {
        return startTime.slice(5, 16) + ' ~ ' + endTime.slice(5, 16)
      }
      return ''
    },
    // 处理告警
    handleAlarm (item) {
      this.formData = _.cloneDeep(item);
      this.dialogVisible = true;
    },
    //查看详情
    handleView(item) {
      this.formView = _.cloneDeep(item);
      this.viewDialog = true;
    },
    // 提交表单
    submitForm () {
      if (!this.formData.userName) {
        Dialog.alert({ title: '提示', message: '请输入处理人姓名' });
        return;
      }
      $.post('mobile/homepage/dealAlarm', this.formData, { contentType: 'application/json' }).then(()=>{
        this.filterAlarms()
        Toast.success('处理完成！');
      }).finally(() => {
        this.dialogVisible = false;
      })
    },
    // 未处理告警下拉加载
    loadPendingAlarms () {
      if (!this.pendingFinished) {
        this.getUntreatedAlarmData();
      }
    },
    // 已处理告警下拉加载
    loadProcessedAlarms () {
      if (!this.processedFinished) {
        this.getProcessedAlarmData();
      }
    },
    // 未处理告警下拉刷新
    onPendingRefresh() {
      this.pendingPage = 1;
      this.pendingFinished = false;
      this.pendingAlarms = [];
      this.getUntreatedAlarmData();
    },
    // 已处理告警下拉刷新
    onProcessedRefresh() {
      this.processedPage = 1;
      this.processedFinished = false;
      this.processedAlarms = [];
      this.getProcessedAlarmData();
    }
  },
  mounted () {
    this.dataListHeight = this.clientHeight - 280;
    this.initData();
  }
}
</script>

<style lang="less" scoped>
.content {
  height: calc(100vh - 50px);
}
.time-range-buttons {
  display: flex;
  align-items: center;
  gap: 12px;

  .time-button {
    width: 35%;
    font-size: 30px;
    padding: 0 20px;
    border-radius: 20px;
  }

  .time-separator {
    font-size: 28px;
    color: #666;
  }

  .filter-button {
    margin-left: 12px;
    font-size: 28px;
    width: 20%;
    padding: 0 25px;
    border-radius: 20px;
  }
}
.monitor-section {
  background: white;
  padding: 16px;
  margin-bottom: 20px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  .section-title {
    font-size: 28px;
    font-weight: bold;
    margin-bottom: 20px;
    color: #333;
    display: flex;
    align-items: center;

    .alarm-count {
      font-size: 27px;
      font-weight: normal;
      color: #FF4D4F;
      margin-left: 8px;
    }
  }
}

.alarm-list {
  overflow-y: auto;
}

.pending-section,
.processed-section {
  .scrollable-list {
    padding-top: 3px;
    height: 35vh;
    overflow-y: auto;
    border-radius: 8px;

    /* 隐藏滚动条但保留滚动功能 */
    &::-webkit-scrollbar {
      width: 0;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;

    .van-pull-refresh {
      height: 100%;
    }
  }

  .van-list {
    min-height: 100%;
  }

  .alarm-item {
    display: flex;
    align-items: flex-start;
    background: #f6f6f6;
    border-radius: 12px;
    padding: 20px;
    margin-bottom: 16px;
    border: 1px solid #e6e6e6;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
    transition: all 0.3s ease;

    &:hover {
      transform: translateY(-2px);
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    }

    &.processed {
      border-left: 4px solid #52C41A;
    }

    &.pending {
      border-left: 4px solid #FF4D4F;
    }

    .alarm-icon {
      margin-right: 16px;
      margin-top: 4px;
    }

    .alarm-content {
      flex: 1;

      .alarm-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 8px;

        .alarm-title {
          font-size: 27px;
          font-weight: bold;
          line-height: 1.4;
          color: #333;
          margin: 0;
        }

        .alarm-time {
          font-size: 22px;
          color: #686868;
          margin-right: -120px;
        }
      }

      .alarm-desc {
        font-size: 25px;
        color: #222121;
        line-height: 1.5;
        margin: 0;
      }

      .alarm-desc-no {
        padding-top: 8px;
        font-size: 25px;
        color: #222121;
        line-height: 1.5;
        margin: 0;
      }

      .alarm-handler {
        display: flex;
        align-items: center;
        font-size: 25px;

        .handler-label {
          color: #52C41A;
          margin-right: 8px;
        }

        .handler-name {
          color: #333;
          font-weight: 500;
        }
      }
    }

    .alarm-action {
      margin-top: 55px;
    }
  }

  .empty-alarm {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 60px 20px;
    text-align: center;

    .empty-icon {
      margin-bottom: 20px;
    }

    .empty-text {
      font-size: 30px;
      font-weight: bold;
      color: #333;
      margin-bottom: 20px;
    }

    .empty-subtext {
      font-size: 25px;
      color: #999;
    }
  }
}

.action-button {
  padding: 0 16px;
  font-size: 22px;
  border-radius: 15px;
  background: linear-gradient(135deg, #1B75F6 0%, #4A90E2 100%);
  border: none;
}

.action-button-2 {
  padding: 0 16px;
  font-size: 22px;
  border-radius: 30px;
  background: linear-gradient(135deg, #70e342 0%, #5f8f4c 100%);
  border: none;
}

.cancel-btn {
  width: 50%;
  color: white;
  background: #5c6064;
  border-radius: 20px;
}

.confirm-btn {
  width: 50%;
  color: white;
  border-radius: 20px;
  background: #34a853;
}

/deep/ .van-picker-column .van-ellipsis {
  color: #1b1a1a !important;
}

/deep/.van-cell__value {
  padding: 0 5px;
  border: 1px rgb(188, 188, 188) solid !important;
}
</style>
